import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { TagsService } from "../services/tags.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-tags-edit",
  templateUrl: "./tags-edit.component.html",
  styleUrls: ["./tags-edit.component.css"],
})
export class TagsEditComponent extends BaseEditComponent implements OnInit {
  private items = [];
  public TagsData: any = {};

  public errors: any = {};

  public breadcrumb: any[] = ["Tags", "Add New"];

  constructor(private router: Router, private tagsService: TagsService, private titleService: Title) {
    super();
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`New Offer Tag | CODE Hospitality CMS`);
    this.loadItems()
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private loadItems() {
    this.loading = true;
    const handle = (result) => {
      const jsonData = result.json();
      this.items = jsonData;
      this.loading = false;
    };
    this.tagsService.getAllTags().subscribe(handle);
  }

  public breadcrumbGoTo(data) {
    this.router.navigate(["/admin/tags"]);
  }

  public create(form) {
    if (!FormUtil.isValid(form)) {
      return;
    }

    const reqData: any = { ...this.TagsData };

    this.loading = true;
    this.tagsService.addTag(reqData.name).subscribe(
      (_) => {
        this.loading = false;
        this.cancel();
      },
      (err) => {
        this.loading = false;
        this.alertError(err);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }

  public cancel() {
    const url = "/admin/offer-tags";
    this.router.navigateByUrl(url);
  }

  get doesTagExist() {
    if (!this.TagsData.name) {
      return false;
    }

    return this.items.includes(this.TagsData.name);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/tags/tags-edit/tags-edit.component.ts